export const CHANGE_PAGING = 'CHANGE_PAGING';
export const CHANGE_SIDEBAR = 'CHANGE_SIDEBAR';

export const ChangePaging = () => ({
  type: 'CHANGE_PAGING',
});
